import { request, RespError, handleFormatRes, tryDecode, fen2Yuan } from '../../utils';
import { PROM_SHOW_GOODS_INFO } from '../../config/url';
import { chunk, flatten } from 'lodash-es';
import { CouponType, ExpireType } from '@tencent/wphk-act-base-types';
/** 分组每页大小 20条 */
const SLICE_PAGE_SIZE = 20;
export var GoodsType;
(function (GoodsType) {
    /** 优惠券，展示券 */
    GoodsType["coupon"] = "coupon";
    /** 暂未支持 */
    GoodsType["qual"] = "qual";
})(GoodsType || (GoodsType = {}));
export { 
/** 优惠券类型 */
CouponType, 
/** 优惠券过期类型 */
ExpireType, };
// 需要转成 int 型的 key 数组
const needParseIntKey = [
    'cdkeyShow',
    'cdkeyType',
    'codeFormat',
    'countDown',
    'couponType',
    'discount',
    'expireDay',
    'expireType',
    'maxDiscount',
    'requiredNum',
    'perCount',
    'spJumpType',
    'totalCount',
    'validNday',
];
// 需要转成 date 型的 key 数组
const needParseDateKey = ['endTime', 'expireTime', 'modifyTime', 'startTime', 'sysTime', 'validTime'];
// 需要转成以元为单位的key数组
// const needFen2YuanKey: string[] = ['discount', 'requiredNum', 'maxDiscount'];
/**
 * 物品静态数据查询
 *
 * https://iwiki.woa.com/pages/viewpage.action?pageId=4007699677&from_wecom=1#%E7%89%A9%E5%93%81%E9%9D%99%E6%80%81%E6%95%B0%E6%8D%AE%E6%9F%A5%E8%AF%A2%E6%8E%A5%E5%8F%A3
 *
 * 接口地址：`/app/promotion/prom_show_goods_info.cgi`
 *
 * 20240322备忘：更新券缓存时间为批次过期之后的93天。（目前的show goods info接口券信息是根据券批次过期时间再加31天的缓存。考虑到可能会有“查看过去3个月活动券信息”的诉求
 * （如往期恒生银行活动，可切换查看3,4,5月活动和券信息）。为了避免券信息31天缓存之后查不到了，现在会把这个缓存时间延长到三个月(93天)。这里也对齐了活动信息的缓存时间（90天）。）
 *
 * @param
 * @returns
 */
export async function promShowGoodsInfo({ goodsType, goodsIdList, }) {
    const chunkGoodsIdList = chunk(goodsIdList, SLICE_PAGE_SIZE);
    // eslint-disable-next-line max-len
    const res = await Promise.all(chunkGoodsIdList.map(ids => slicePromShowGoodsInfo({ goodsType, goodsIdList: ids })));
    const resCouponList = flatten(res.map(resItem => resItem.goodsArr));
    // ...res?.[0]，将除了goodsArr的其他接口数据返回
    const returnRes = Object.assign(Object.assign({}, res[0]), { goodsArr: resCouponList });
    return returnRes;
}
async function slicePromShowGoodsInfo({ goodsType, goodsIdList }) {
    try {
        // 参数格式化
        const params = {
            t: new Date().getTime(),
            goods_type: goodsType,
            goods_id_list: (goodsIdList || []).join('|'),
        };
        // 接口请求
        const result = await request.get(PROM_SHOW_GOODS_INFO, { params });
        if (result) {
            // 正常的返回
            if ((result === null || result === void 0 ? void 0 : result.retcode) === '0') {
                const res = handleFormatRes({
                    result,
                    needParseIntKey,
                    needParseDateKey,
                    // needFen2YuanKey,
                    transformer: (res) => (Object.assign(Object.assign({}, res), { goodsArr: (res.goodsArr || []).map((ele) => {
                            const condition = ele.couponCondition;
                            delete ele.couponCondition;
                            return Object.assign(Object.assign({}, ele), { couponName: tryDecode(ele.couponName), couponCond: tryDecode(condition), couponRange: tryDecode(ele.couponRange), rawDiscount: ele.discount, discount: ele.couponType === CouponType.DISC ? ele.discount : +fen2Yuan(ele.discount), requiredNum: +fen2Yuan(ele.requiredNum), maxDiscount: +fen2Yuan(ele.maxDiscount), customizeJumpName: tryDecode(ele.customizeJumpName), customizeJumpUrl: tryDecode(ele.customizeJumpUrl), couponTandc: tryDecode(ele.couponTandc) });
                        }) })),
                });
                return res;
            }
            // 状态码错误的返回
            throw new RespError(result.retcode, result.retmsg, result);
        }
        throw result;
    }
    catch (error) {
        throw error;
    }
}
